<template>
  <div>
    <data-manage-page 
      ref="baseTable"
      :store-namespace="storeNamespace"
      :props-filter="buildFilter()" 
      :tag-index="tagIndex" 
      :columns="columns"
      :fields="fields"
      :page="pagination"
      @update:selection="handleSelectionChange"
      @update:pagination="handlePaginationChange"
    >
      <!-- Custom action button -->
      <template #actions>
        <a-button type="primary" @click="() => visible.changeUseStatusModal = true" icon="fire"> Change Use Status</a-button>
      </template>

      <!-- Custom filters -->
      <template #filters>
        <a-form-model-item label="Use Status">
          <a-select placeholder="Use Status" style="width: 150px;" :allowClear="true" v-model="filter.use_status">
            <a-select-option :value="1"><a-tag>UN USE</a-tag></a-select-option>
            <a-select-option :value="2"><a-tag color="orange">IN USE</a-tag></a-select-option>
            <a-select-option :value="3"><a-tag color="green">USED</a-tag></a-select-option>
            <a-select-option :value="4"><a-tag color="pink">X REJECT</a-tag></a-select-option>
            <a-select-option :value="5"><a-tag color="purple">X TEMP BLOCK</a-tag></a-select-option>
            <a-select-option :value="6"><a-tag color="red">DIED</a-tag></a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="Domains">
          <a-select allowClear mode="tags" placeholder="Domains" style="width: 200px;" v-model="filter.domains">
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="Quốc gia">
          <a-select allowClear mode="tags" placeholder="Countries" style="width: 200px;" v-model="filter.countries">
          </a-select>
        </a-form-model-item>
      </template>

      <!-- #region
        Custom render table 
      -->
      <a slot="uid" slot-scope="{ text }" :href="('mailto:' + text)" target="_blank">
        {{ text }}
      </a>

      <template slot="country" slot-scope="{ text }">
        <a-tag v-if="!!text">{{ text.toUpperCase() }}</a-tag>
      </template>

      <template slot="use_status" slot-scope="{ text }">
        <a-tag v-if="text == 1">UN USE</a-tag>
        <a-tag v-if="text == 2" color="orange">IN USE</a-tag>
        <a-tag v-if="text == 3" color="green">USED</a-tag>
        <a-tag v-if="text == 4" color="pink">X REJECT</a-tag>
        <a-tag v-if="text == 5" color="purple">X TEMP BLOCK</a-tag>
        <a-tag v-if="text == 6" color="red">DIED</a-tag>
      </template>

      <template slot="tag_ids" slot-scope="{ record }">
        <template v-for="tag_id in record.tag_ids">
          <a-tag :key="tag_id" closable @close="handleUnassignTag(record.id, tag_id)"
            v-if="tagExisted(tag_id)">{{ getTagTitleById(tag_id) }}</a-tag>
        </template>
      </template>

      <span v-if="!!text" slot="registration_time" slot-scope="{ text }">
        {{ new Date(text).toLocaleString() }}
      </span>
      <!-- #endregion -->
    </data-manage-page>

    <!-- Modal change use status -->
    <a-modal id="change-use-status-modal" width="300px" v-model="visible.changeUseStatusModal" title="Thay đổi trạng thái sử dụng" okText="Thay đổi" @ok="handleChangeUseStatus">
      <div><p>Bạn đã chọn <b><i>{{selectedDataUids.length || pagination.total}}</i></b> accounts!</p></div>
      <div><p>Trạng thái mới:</p></div>
      <a-select placeholder="Use Status" style="width: 100%;" :allowClear="true" v-model="newUseStatus">
        <a-select-option :value="1"><a-tag>UN USE</a-tag></a-select-option>
        <a-select-option :value="2"><a-tag color="orange">IN USE</a-tag></a-select-option>
        <a-select-option :value="3"><a-tag color="green">USED</a-tag></a-select-option>
        <a-select-option :value="4"><a-tag color="pink">X REJECT</a-tag></a-select-option>
        <a-select-option :value="5"><a-tag color="purple">X TEMP BLOCK</a-tag></a-select-option>
        <a-select-option :value="6"><a-tag color="red">DIED</a-tag></a-select-option>
      </a-select>
    </a-modal>
  </div>
</template>

<style></style>

<script>
import DataManagePage from '../data-layout/DataManagePage.vue';
import { mapActions, mapGetters } from 'vuex';

const fields = [
  { title: 'UID', key: 'uid' },
  { title: 'Password', key: 'password' },
  { title: 'Oauth2 Client ID', key: 'oauth_2_client_id' },
  { title: 'Oauth2 Refresh Token', key: 'oauth_2_refresh_token' },
  { title: 'Domain', key: 'domain' },
  { title: 'Country', key: 'country' },
  { title: 'Name', key: 'name' },
  { title: 'Registration time', key: 'registration_time' },
  { title: 'Note', key: 'note' },
  { title: 'Useragent', key: 'useragent' },
];

const columns = [
  {
    title: 'UID',
    dataIndex: 'uid',
    key: 'uid',
    width: '300px',
    fixed: 'left',
    scopedSlots: { customRender: 'uid' }
  },
  {
    title: 'Use Status',
    dataIndex: 'use_status',
    width: '130px',
    key: 'use_status',
    scopedSlots: { customRender: 'use_status' }
  },
  {
    title: 'Country',
    dataIndex: 'country',
    width: '90px',
    key: 'country',
    scopedSlots: { customRender: 'country' }
  },
  {
    title: 'Tags',
    dataIndex: 'tag_ids',
    key: 'tag_ids',
    scopedSlots: { customRender: 'tag_ids' }
  },
  {
    title: 'Tên',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'Thời gian tạo',
    dataIndex: 'registration_time',
    key: 'registration_time',
    scopedSlots: { customRender: 'registration_time' }
  },
  {
    title: 'Note',
    dataIndex: 'note',
    key: 'note',
    fixed: 'right',
    width: '400px',
  },
  {
    title: 'Thao tác',
    fixed: 'right',
    width: '150px',
    scopedSlots: { customRender: 'operation' },
  }
];

export default {
  name: 'HotmailAccount',
  components: {
    DataManagePage,
  },
  data() {
    return {
      app: this.$root.$children[0],
      columns,
      fields,
      filter: {},

      visible: {
        changeUseStatusModal: false,
      },

      tagIndex: 'hotmail-account',
      storeNamespace: 'hotmailAccount',

      selectedData: [],
      selectedDataIds: [],
      selectedDataUids: [],

      newUseStatus: undefined,

      pagination: {
        total: 0,
        pageSize: 10,
        current: 1,
        showSizeChanger: true,
        pageSizeOptions: ['10', '30', '50', '100', '200', '500', '1000'],
      },
    };
  },

  watch: {
    filter: {
      deep: true,
      handler() {
        this.buildFilter();
      },
    },
  },

  computed: {
    ...mapGetters('tag', {
      tags: 'getTags'
    }),

    ...mapGetters('job', {
      jobs: "getJobs"
    }),
  },

  methods: {
    ...mapActions("hotmailAccount", {
      unassignTag: "unassignTag",
      changeUseStatus: "changeUseStatus"
    }),

    ...mapActions("tag", {
      fetchTags: "fetchTags",
      addTag: "addTag",
      assignTag: "assignTag",
      deleteTag: "deleteTag"
    }),

    handleSelectionChange(selection) {
      this.selectedDataIds = selection.selectedDataIds;
      this.selectedDataUids = selection.selectedDataUids;
      this.selectedData = selection.selectedData;
    },

    handlePaginationChange(pagination) {
      this.pagination.total = pagination.total;
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
    },
    
    buildFilter() {
      const filter = {};

      if (this.filter.countries && this.filter.countries?.length > 0) {
        filter.countries = this.filter.countries;
      }

      if (this.filter.domains && this.filter.domains?.length > 0) {
        filter.domains = this.filter.domains;
      }

      if (this.filter.use_status) {
        filter.use_status = this.filter.use_status;
      }

      return filter;
    },

    maskedEmail(email) {
      if (!email) return '';
      const [name, domain] = email.split('@');
      if (!name || !domain) return email;
      
      const maskedName = name[0] + '*'.repeat(Math.max(name.length - 1, 1));
      
      return `${maskedName}@${domain}`;
    },

    getTagTitleById(tagId) {
      const tag = this.tagExisted(tagId);

      if (!tag) {
        return null;
      }

      return tag.title;
    },

    tagExisted(tagId) {
      if (tagId && this.tags.length > 0) {
        const tag = this.tags.find(tag => tag.id == tagId);

        if (tag) {
          return tag;
        }
      }

      return false;
    },

    async handleUnassignTag(id, tag_id) {
      this.app.callApi(async () => {
        await this.unassignTag({id, tag_id});
        this.$message.success('Gỡ tag thành công!');
      });
    },

    async handleChangeUseStatus() {
      this.app.callApi(async () => {
        const ids = [...this.selectedDataIds];
        const filter = (ids && ids.length > 0) ? {ids} : this.buildFilter();

        filter.new_status = this.newUseStatus;

        await this.changeUseStatus(filter);
        this.visible.changeUseStatusModal = false;
        this.$message.success('Thay đổi trạng thái sử dụng thành công!');
        this.$refs.baseTable.wrapFetchData();
      });
    },
  },
};
</script>